<script>
    import TableComponentContainer from "../../../../Common/TableComponentContainer.svelte";

    export let row = {};
</script>

<TableComponentContainer customContainerClass="min-w-[100px]">
    <div class="flex items-center justify-start text-left w-full">
        {row.id}
    </div>
</TableComponentContainer>
